<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>店铺装修</el-breadcrumb-item>
            <el-breadcrumb-item>底部菜单</el-breadcrumb-item>
        </el-breadcrumb>
        <!--		数据是list 通过list展示-->
        <div class="btns">
            <el-button type="primary" size="small" @click="add">添加底部菜单</el-button>
        </div>
        <el-table :data="list" border>
            <el-table-column label="图片">
				<template slot-scope="scope">
					<div id="" style="display: flex;align-items: center;">
						<img :src="scope.row.pic" style="width: 60px;">
					</div>
				</template>
			</el-table-column>
            <el-table-column prop="page" label="链接"></el-table-column>
            <el-table-column prop="type" label="类型"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [],
                isLoad: false,
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('', {
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 跳转到edit添加
            add() {
                this.$router.push({path: '/ShoppingMall/menuEdit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id) {
                this.$router.push({
                    path: '/ShoppingMall/menuEdit.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/store/member/levelDelete', {
                    data: [
                        id
                    ]
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose: false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>